document.addEventListener("DOMContentLoaded", (event) => {
  const quantityBtn = document.querySelectorAll('.quantity-dropdown');
  quantityBtn.forEach((btn) => {
    btn.addEventListener('click', () => {
      const dropdownList = btn.querySelector('.quantity-list');
      if (dropdownList.classList.contains('quantity-list--open')) {
        dropdownList.classList.remove('quantity-list--open');
        return;
      }
      dropdownList.classList.add('quantity-list--open');
    })
  })
  
  const quantitySelectors = document.querySelectorAll('.quantity-list__item');
  quantitySelectors.forEach((selector) => {
    selector.addEventListener('click', (event) => {
      const lineItemId = event.currentTarget.dataset.lineItemId;
      const inputFieldWrapper = document.querySelector(`.quantity-input-field[data-id="${lineItemId}"`);
      const inputField = document.querySelector(`.cart__quantity-field[data-id="${lineItemId}"`);
      const quantityText = inputFieldWrapper.querySelector('.quantity-count');
      inputField.value = Number(event.currentTarget.textContent);
      inputField.dispatchEvent(new Event('change'));
      quantityText.textContent = event.currentTarget.textContent;
    })
  })
})